"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stopwatch = void 0;
var Stopwatch = /** @class */ (function () {
    function Stopwatch() {
    }
    Stopwatch.prototype.start = function () {
        this.beginTime = Date.now();
        return this;
    };
    Stopwatch.prototype.stop = function () {
        this.endTime = Date.now();
        return this;
    };
    Stopwatch.prototype.elapsedMilliseconds = function () {
        if (!this.endTime)
            return Date.now() - this.beginTime;
        return this.endTime - this.beginTime;
    };
    Stopwatch.prototype.elapsedString = function () {
        return "elapsed " + this.elapsedMilliseconds() + "ms";
    };
    Stopwatch.startNew = function () {
        return new Stopwatch().start();
    };
    return Stopwatch;
}());
exports.Stopwatch = Stopwatch;
